import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const sidecarTriggerUpdateCheckAtom = createMutationAtomFactory(
  'settings.sidecarTriggerUpdateCheck',
  (params: { id: string }) => ({
    iotSidecarTriggerUpdateCheck: {
      __args: { id: params.id },
    },
  }),
);
